import { render, staticRenderFns } from "./RecalculateValue.vue?vue&type=template&id=38c86e5d&"
import script from "./RecalculateValue.vue?vue&type=script&lang=js&"
export * from "./RecalculateValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports